import { create } from 'zustand';

interface HoverState {
    hoveredPortId: string | null;
    hoveredAssetId: string | null;
    showTooltipId: string | null;

    setPortHovered: (portId: string | null, assetId: string | null) => void;
    setNodeHovered: (assetId: string | null) => void;
}

export const useHoverStore = create<HoverState>((set) => ({
    hoveredPortId: null,
    hoveredAssetId: null,
    showTooltipId: null,

    setPortHovered: (portId, assetId) =>
        set({
            hoveredPortId: portId,
            hoveredAssetId: assetId,
            showTooltipId: null,
        }),

    setNodeHovered: (assetId) =>
        set({
            hoveredPortId: null,
            hoveredAssetId: assetId,
            showTooltipId: assetId,
        }),
}));
